import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';

export const GetSubscriptionInputValidationSchema = z.object({
  subscriptionId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the subscription to retrieve. Use `list_subscriptions` first if you need to discover the subscription ID by email, name, customer, page, or date range.',
  }),
  livemode: LivemodeFilterValidationSchema,
});
